"use client"

import { Carrot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CarrotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CarrotIcon = component(Icon)({ as: Carrot })
